import type { DeployServiceName } from "@rebuild/shared";

export const SERVICE_LABELS: Record<DeployServiceName, string> = {
  webapp: "Webapp",
  api: "API Server",
  tools: "Tools",
};

export const SERVICE_COLORS: Record<DeployServiceName, string> = {
  webapp: "bg-blue-500",
  api: "bg-emerald-500",
  tools: "bg-violet-500",
};
